import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const cycleCountApi = {
  get: async (filter) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cycleCounts`, { params: { ...filter } });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getForSchedulerTasks: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cycleCounts/v2/for-scheduler-tasks`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getResult: async (cycleCountRequestId) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cycleCounts/results/${cycleCountRequestId}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getPendingCycleCountRequests: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cycleCounts/pending`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getById: async (id) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cycleCounts/${id}`);
      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getUsers: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cycleCounts/assignable-users`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  update: async (data, id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/cycleCounts/${id}`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  changeStatus: async (data, id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/cycleCounts/changeStatus/${id}`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  applyActualQuantity: async (id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/cycleCounts/applyActualQuantity/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  batchApplyActualQuantity: async (ids) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/cycleCounts/batch-apply-actual-quantity`, ids);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  updateResult: async (data, id) => {
    try {
      const res = await axiosApiInstance.put(`${apiRoot}/cycleCounts/result/${id}`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  create: async (data) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/cycleCounts`, data);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  repeatRequest: async (id) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/cycleCounts/repeatRequest/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  resetRequest: async (id) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/cycleCounts/reset/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  undoActualization: async (id) => {
    try {
      const res = await axiosApiInstance.post(`${apiRoot}/cycleCounts/v1/undo-actualization/${id}`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default cycleCountApi;
